import Action3 from './action3';

export default class {

    static extends = [Action3]
    
    changeName() {
        this.models.m1.set({
            name: '明天在来'
        });
    }

    didMount() {
        console.log(this.models);
        setTimeout(() => {
            this.changeName();
            this.models.m1.testName();
            this.showAbc();
            this.showAbcde();
            this.models.m1.set({
                'info.age': 88,
                'info.school.grade': 99
            });
            console.log(this.models.m1.get());
        }, 6000);


        console.log(this.models.m1.get('name'));
    }
}